<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <!-- //文本搜索内容 -->
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="查询分类" required>
                                <a-select ref="cxfl" default-value="资信信息" style="width:100%" v-model="queryParams.cxfl" @change="handleChange">
                                    <a-select-option value="资信信息">
                                        资信信息
                                    </a-select-option>
                                    <a-select-option value="其他资质证书">
                                        其他资质证书
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="6" v-show="isShow_cxtj1">
                            <a-form-item label="资信等级">
                                <a-select ref="zxdj" default-value="" style="width:100%" v-model="queryParams.zxdj" allowClear>
                                    <a-select-option value="甲级">
                                        甲级
                                    </a-select-option>
                                    <a-select-option value="乙级">
                                        乙级
                                    </a-select-option>
                                    <a-select-option value="乙级预评价">
                                        乙级预评价
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="6" v-show="isShow_cxtj1">
                            <a-form-item label="资信类别">
                                <a-select ref="zxlb" default-value="" style="width:100%" v-model="queryParams.zxlb" allowClear>
                                    <a-select-option value="综合资信">
                                        综合资信
                                    </a-select-option>
                                    <a-select-option value="专业资信">
                                        专业资信
                                    </a-select-option>
                                    <a-select-option value="专项资信">
                                        专项资信
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="6" v-show="isShow_cxtj2">
                            <a-form-item label="证书类别">
                                <a-select ref="zslb" default-value="" style="width:100%" v-model="queryParams.zslb" allowClear>
                                    <a-select-option value="工程设计">
                                        工程设计
                                    </a-select-option>
                                    <a-select-option value="招标代理">
                                        招标代理
                                    </a-select-option>
                                    <a-select-option value="工程监理">
                                        工程监理
                                    </a-select-option>
                                    <a-select-option value="设备监理">
                                        设备监理
                                    </a-select-option>
                                    <a-select-option value="工程项目管理">
                                        工程项目管理
                                    </a-select-option>
                                    <a-select-option value="其他">
                                        其他
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="6" v-show="isShow_cxtj2">
                            <a-form-item label="证书等级">
                                <a-input v-model="queryParams.zsdj" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="会员单位">
                                <a-checkbox v-model="queryParams.hydwbj" defaultChecked />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="单位名称">
                                <a-input v-model="queryParams.dwmc" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="专业名称">
                                <a-select v-model="queryParams.zymc" mode="multiple">
                                    <a-select-option v-for="item in majors" :key="item.dict_value" :value="item.dict_text">
                                        {{ item.dict_text }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="18">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData" style="margin-right: 8px">查询</a-button>
                                <a-button @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>

        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                ></vxe-toolbar>
                <!-- 表格 -->
                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    auto-resize
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(2)"
                    header-align="center"
                    highlight-hover-row
                    highlight-current-row
                    show-overflow="tooltip"
                    :data="tableData"
                    @cell-dblclick="
                        ({ row }) => {
                            visible = true;
                            currentRow = row;
                            loadItemDataZXDJ();
                            loadItemDataQTZZZS();
                        }
                    "
                >
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="dwmc" title="单位名称"> </vxe-table-column>
                    <vxe-table-column field="zcdz" title="注册地址" min-width="300"> </vxe-table-column>
                    <vxe-table-column field="gddh" title="固定电话" align="center"> </vxe-table-column>
                    <vxe-table-column field="qymc" title="属地" align="center"> </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    style="margin-top: 5px"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
        <a-modal v-model="visible" :width="1300" title="详情" :footer="null">
            <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="单位名称">
                            {{ currentRow.dwmc }}
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="注册地址">
                            {{ currentRow.zcdz }}
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="属地">
                            {{ currentRow.qymc }}
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="固定电话">
                            {{ currentRow.gddh }}
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
            <!-- 资信等级及专业信息明细表格 -->
            <FGCollapsiblePanel title="资信等级及专业信息" v-if="isShow_cxtj1">
                <vxe-table
                    ref="ZXDJitemTable"
                    size="mini"
                    resizable
                    auto-resize
                    row-id="id"
                    align="left"
                    height="300"
                    header-align="center"
                    highlight-hover-row
                    highlight-current-row
                    show-overflow="tooltip"
                    :data="editItemDataZXDJ"
                >
                    <vxe-table-column field="zxdj" title="资信等级" width="100" align="center"></vxe-table-column>
                    <vxe-table-column field="zxlb" title="资信类别" width="100" align="center"></vxe-table-column>
                    <vxe-table-column field="zymc" title="专业（业务）名称" width="160" align="center"></vxe-table-column>
                    <vxe-table-column field="zslb" title="证书类别" width="120" align="center"></vxe-table-column>
                    <vxe-table-column field="zsbh" title="证书编号" width="120"></vxe-table-column>
                    <vxe-table-column field="zsmc" title="证书名称" width="180"></vxe-table-column>
                    <vxe-table-column field="zsrq" title="证书日期" width="100" align="center">
                        <template v-slot="{ row }">
                            <span> {{ $FG_util.formatDate(row.zsrq, "YYYY-MM-DD") }} </span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="zzyxq" title="资质有效期" width="120" align="center"></vxe-table-column>
                    <vxe-table-column field="zsdqrq" title="证书到期日期" width="100" align="center">
                        <template v-slot="{ row }">
                            <span> {{ $FG_util.formatDate(row.zsdqrq, "YYYY-MM-DD") }} </span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="bz" title="备注" width="120"></vxe-table-column>
                </vxe-table>
            </FGCollapsiblePanel>
            <!-- 其他资质证书明细表格 -->
            <FGCollapsiblePanel title="其他资质证书" v-if="isShow_cxtj2">
                <vxe-table
                    ref="QTZZZSitemTable"
                    size="mini"
                    resizable
                    keep-source
                    auto-resize
                    row-id="id"
                    align="left"
                    header-align="center"
                    highlight-hover-row
                    highlight-current-row
                    show-overflow="tooltip"
                    :data="editItemDataQTZZZS"
                >
                    <vxe-table-column field="zsmc" title="证书名称" min-width="200" sortable></vxe-table-column>
                    <vxe-table-column field="zsbh" title="证书编号" width="150"></vxe-table-column>
                    <vxe-table-column field="zymc" title="专业名称" width="150"></vxe-table-column>
                    <vxe-table-column field="zzdj" title="资质等级" width="100" align="center"></vxe-table-column>
                    <vxe-table-column field="zsrq" title="证书日期" width="110" align="center">
                        <template v-slot="{ row }">
                            <span> {{ $FG_util.formatDate(row.zsrq, "YYYY-MM-DD") }} </span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="zzyxq" title="资质有效期(年)" width="130" align="center"></vxe-table-column>
                    <vxe-table-column field="zsdqrq" title="证书到期日期" width="130" align="center">
                        <template v-slot="{ row }">
                            <span> {{ $FG_util.formatDate(row.zsdqrq, "YYYY-MM-DD") }} </span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="bz" title="备注" width="200"></vxe-table-column>
                </vxe-table>
            </FGCollapsiblePanel>
        </a-modal>
    </div>
</template>

<script>
export default {
    name: "Zczxdwzzcx",
    components: {},
    data() {
        return {
            tableData: [], //表格数据
            queryParams: { cxfl: "资信信息", hydwbj: "true" },
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "dwmc",
                order: "desc"
            },
            tableDataLoading: false,
            isShow_cxtj1: true,
            isShow_cxtj2: false,
            majors: [],
            visible: false,
            currentRow: {},
            //资信等级及专业信息
            editItemDataZXDJ: [],
            //其它资质证书
            editItemDataQTZZZS: []
        };
    },

    mounted() {
        this.getMajor();
    },
    methods: {
        handleChange(value) {
            if (value === "资信信息") {
                this.isShow_cxtj1 = true;
                this.isShow_cxtj2 = false;
            } else if (value === "其他资质证书") {
                this.isShow_cxtj1 = false;
                this.isShow_cxtj2 = true;
            }
        },
        //点击页码
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        //查询列表数据
        loadData(id) {
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/jsaec/szxdwfwpt/zczxdwzxcx/list",
                    {
                        funid: "DW9006",
                        defaulttablename: "DW_DWXX",
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                });
        },
        //重置文本内容
        reset() {
            this.queryParams = { cxfl: "资信信息", hydwbj: "true" };
        },
        getMajor() {
            this.$FG_http
                .post(
                    "./api/jsaec/szxdwfwpt/zczxdwzxcx/getMajor",
                    {},
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        this.majors = data.data;
                    } else {
                        // 数据加载失败清空表格
                        this.majors = [];
                    }
                });
        },
        // 加载明细表数据
        loadItemDataZXDJ() {
            this.editItemDataZXDJ = [];
            this.$FG_http
                .post(
                    "./api/jsaec/szxdwfwpt/zczxdwzxcx/listItemZXDJ",
                    {
                        dwid: this.currentRow.id,
                        sort: {
                            field: "zsbh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        this.editItemDataZXDJ = data.data;
                    }
                });
        },
        // 加载明细表数据
        loadItemDataQTZZZS() {
            this.editItemDataQTZZZS = [];
            this.$FG_http
                .post(
                    "./api/jsaec/szxdwfwpt/zczxdwzxcx/listItemQTZZZS",
                    {
                        dwid: this.currentRow.id,
                        sort: {
                            field: "zsbh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        this.editItemDataQTZZZS = data.data;
                    }
                });
        }
    }
};
</script>
